<template>
  <div class="text-lg max-w-2xl">
    <p class="text-2xl italic">Calculate and collaborate on project prices.</p>
    <p>This app is currently a prototype. Please use it in any way you find useful.</p>
    <p>Caveats:<br />
      &ndash; things will actively change and possibly break<br />
      &ndash; changes are saved to your browser's local storage<br />
      &ndash; you can &ldquo;reset&rdquo; the app to its default configuration (<a href="/settings">Settings &gt; Clear storage</a>)
    </p>
    <p>We welcome any feedback you have: <a href="mailto:feedback@sort.work">feedback@sort.work</a></p>
    <p>Learn more about its purpose, context and features in <a href="http://deck.sort.work">our presentation</a>.</p>
    <p>Thanks,<br />
      Chris &amp; Ben</p>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
  methods: {
  },
  mounted() {
    this.$store.dispatch('prices/clearPrice')
  }
};
</script>
